import Message from '../models/message'
import { ChatModel, EngineCreateOpts, ModelCapabilities, ModelMeta } from '../types/index'
import { LlmRole } from '../types/llm'
import { PROVIDER_BASE_URLS } from '../defaults'
import { minimatch } from 'minimatch'
import OpenAI from './openai'

//
// https://llama.developer.meta.com/docs/overview
//

export const metaBaseURL = PROVIDER_BASE_URLS.meta!

export default class extends OpenAI {

  constructor(config: EngineCreateOpts) {
    super(config, {
      apiKey: config.apiKey,
      baseURL: config.baseURL || metaBaseURL,
    })
  }

  getId(): string {
    return 'meta'
  }

  supportsServiceTiering(): boolean {
    return false
  }
  
  getModelCapabilities(model: ModelMeta): ModelCapabilities {
    const visionGlobs = [ '*Llama-4-*' ]
    return {
      tools: true,
      vision: visionGlobs.some((m) => minimatch(model.id, m)),
      reasoning: false,
      caching: false,
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  modelSupportsStructuredOutput(model: ChatModel): boolean {
    return false
  }

  get systemRole(): LlmRole {
    return 'system'
  }

  async getModels(): Promise<ModelMeta[]> {
    // need an api key
    if (!this.client.apiKey) {
      return []
    }

    // do it
    return await super.getModels() as ModelMeta[]

  }

  protected setBaseURL() {
    // avoid override by super
  }

  requiresFlatTextPayload(model: ChatModel, msg: Message): boolean {
    return super.defaultRequiresFlatTextPayload(model, msg)
  }

}
